import { createContext } from 'react';

import type { ShigoSession } from '../features/auth/model';

export type ShigoSessionContextValue = {
  session: ShigoSession | null;
  setSession: (session: ShigoSession) => void;
  clearSession: () => void;
  isAuthenticated: boolean;
};

export const ShigoSessionContext = createContext<ShigoSessionContextValue | null>(null);
